/* sts-scroll-ind.js: the scroll indicator under every horizontal scroller
   (prototype v6, handoff 1.3).

   A 4px track under the row, navy thumb = visible / total width (min 14%),
   following scrollLeft. Shown only while the row overflows.

   Rows: SEL; mark new rows data-sts-scrollind-row. Later rows: MutationObserver.

   Colour (v6.1 handoff 1.4): the first ancestor with an opaque background
   decides; a luminance under .45 (the navy band) marks it data-dark="1".

   Styles: .sts-scrollind in assets/sts-components.css. */
(function () {
  'use strict';
  /* Decorative: no ResizeObserver, no bars. */
  if (!window.ResizeObserver) return;
  var SEL = '.sts-scroller,.sts-row__scroller,.sts-results__grid,.sts-bundle__list,.sts-filters__scroller,' +
            '.sts-crel .sts-lib-grid,[data-slq-ba-row],[data-sts-scrollind-row]';
  var bars = new WeakMap();
  var pending = false;

  function isDark(el) {
    for (; el && el !== document.documentElement; el = el.parentElement) {
      var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/.exec(getComputedStyle(el).backgroundColor);
      if (m && (m[4] === undefined || +m[4] > 0.5)) return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255 < 0.45;
    }
    return false;
  }

  /* Reads run in the ResizeObserver callback (after layout), all before any
     write: nothing forces a style or layout pass. */
  function measure(row, bar) {
    var sw = row.scrollWidth, cw = row.clientWidth;
    var m = { bar: bar, on: cw > 0 && sw > cw + 4 };
    if (!m.on) return m;
    m.w = Math.max(14, cw / sw * 100);
    m.l = Math.min(1, row.scrollLeft / Math.max(1, sw - cw)) * (100 - m.w);
    return m;
  }

  function apply(m) {
    var bar = m.bar, v = m.on ? '1' : '0';
    if (bar.getAttribute('data-on') !== v) bar.setAttribute('data-on', v);
    if (!m.on) return;
    if (m.dark) bar.setAttribute('data-dark', m.dark);
    bar.firstChild.style.width = m.w + '%';
    bar.firstChild.style.left = m.l + '%';
  }

  /* Bar host: past display:contents wrappers; after a whole nowrap flex row. */
  function hostOf(row) {
    var host = row, p = row.parentElement;
    while (p && p !== document.body && getComputedStyle(p).display === 'contents') { host = p; p = p.parentElement; }
    if (p && p !== document.body) {
      var cs = getComputedStyle(p);
      if ((cs.display === 'flex' || cs.display === 'inline-flex') && cs.flexDirection.indexOf('row') === 0 && cs.flexWrap === 'nowrap') host = p;
    }
    return host;
  }

  function update(rows) {
    var ms = rows.map(function (row) {
      var bar = bars.get(row), host = !bar && hostOf(row);
      var m = measure(row, bar || document.createElement('div'));
      /* Colour: decided when the bar first shows, once the styles are in. */
      if (m.on && !(bar && bar.hasAttribute('data-dark'))) m.dark = isDark(bar ? bar.parentElement : host.parentElement) ? '1' : '0';
      m.row = row; m.host = host;
      return m;
    });
    ms.forEach(function (m) {
      if (m.host) {
        var row = m.row, bar = m.bar;
        bar.className = 'sts-scrollind';
        bar.setAttribute('aria-hidden', 'true');
        bar.appendChild(document.createElement('span'));
        m.host.insertAdjacentElement('afterend', bar);
        bars.set(row, bar);
        row.addEventListener('scroll', function () { update([row]); }, { passive: true });
      }
      apply(m);
    });
  }

  var seen = new WeakSet();
  var ro = new ResizeObserver(function (es) {
    update(es.map(function (e) { return e.target; }));
  });

  /* Search only ADDED subtrees: the apps mutate the DOM most frames while the
     page loads, and a whole-document query per frame was this file's cost. */
  var added = [];
  function scan() {
    pending = false;
    var list = added, rows = [];
    added = [];
    list.forEach(function (n) {
      if (!n.isConnected) return;
      if (n.matches(SEL)) rows.push(n);
      rows.push.apply(rows, n.querySelectorAll(SEL));
    });
    rows.forEach(function (r) { if (!seen.has(r)) { seen.add(r); ro.observe(r); } });
  }

  function schedule(n) {
    added.push(n);
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(scan);
  }

  var root = document.documentElement;
  var all = function () { schedule(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  window.addEventListener('load', all);
  new MutationObserver(function (rs) {
    rs.forEach(function (r) { [].forEach.call(r.addedNodes, function (n) { if (n.nodeType === 1) schedule(n); }); });
  }).observe(root, { childList: true, subtree: true });
})();
